import React, { useEffect, useState } from "react";
import axios from "../../API/axios";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import { Form } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useNewsFeedStore from "../NewsFeed/useNewsFeedStore";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import OtpInput from "react-otp-input";

const ChangeEmailAddress = () => {
  const [newEmail, setNewEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const { t } = useTranslation();
  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [errorToastMessage, setErrorToastMessage] = useState("");
  const language = localStorage.getItem("Lang");
  const [showErrorToast, setShowErrorToast] = useState(false);

  const [flag, setFlag] = useState(false);
  const [otp, setOtp] = useState("");
  const [loadOTP, setLoadOTP] = useState(false);
  const [otpSessionId, setOtpSessionId] = useState("");
  const [otpUserId, setOtpUserId] = useState("");
  const [pendingEmail, setPendingEmail] = useState("");
  const [otpMessage, setOtpMessage] = useState("");
  const [minutes, setMinutes] = useState(1);
  const [seconds, setSeconds] = useState(30);

  const resetToasts = () => {
    setShowToast(false);
    setToastMessage("");
    setShowWarningToast(false);
    setWarningToastMessage("");
    setShowErrorToast(false);
    setErrorToastMessage("");
  };

  const handleChangeEmail = async () => {
    const sessionId = localStorage.getItem("sessionId");
    const token = localStorage.getItem("token");

    setLoading(true);
    resetToasts();

    if (!sessionId || !token) {
      setErrorToastMessage("Authentication error. Please log in again.");
      setShowErrorToast(true);
      setLoading(false);
      return;
    }
    if (!newEmail) {
      setWarningToastMessage("Please enter a new email address.");
      setShowWarningToast(true);
      setLoading(false);
      return;
    }

    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      newEmail: newEmail,
      password: password,
      langKey: language === "en" ? "" : language,
    };

    try {
      const response = await axios.post("/Account/ChangeEmailAddress", data);
      const responseData = response.data?.responseData || {};
      const sessionFromApi =
        responseData.sessionID ||
        responseData.sessionId ||
        responseData.SessionID ||
        "";
      const userFromApi =
        responseData.UserID ||
        responseData.userID ||
        responseData.UserId ||
        responseData.userId ||
        "";

      setPendingEmail(newEmail);
      setOtpSessionId(sessionFromApi);
      setOtpUserId(userFromApi);
      setOtp("");
      setOtpMessage(
        response.data.message ||
          "Please verify the OTP sent to your new email address."
      );
      setMinutes(1);
      setSeconds(30);
      setFlag(true);
      setToastMessage(response.data.message || "OTP sent to your new email.");
      setShowToast(true);
      setLoading(false);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
        setLoading(false);
      } else {
        setErrorToastMessage(
          error.response?.data?.message || "Something went wrong."
        );
        setShowErrorToast(true);
        setLoading(false);
      }
    }
  };

  const handleOtpModalClose = () => {
    setFlag(false);
    setOtp("");
    setLoadOTP(false);
  };

  const confirmEmailOtp = async (e) => {
    e.preventDefault();
    if (!otp || otp.length < 4 || !otpSessionId || !otpUserId) return;
    resetToasts();
    setLoadOTP(true);
    try {
      const res = await axios.post(
        `OAuth/ConfirmAccountByOTP?OTP=${otp}&SessionID=${otpSessionId}&UserID=${otpUserId}&DeviceType=Web`
      );
      const emailToStore = pendingEmail || newEmail;
      if (emailToStore) {
        localStorage.setItem("user-email", emailToStore);
        setEmail(emailToStore);
      }
      setToastMessage(res.data.message || "Email verified successfully.");
      setShowToast(true);
      setFlag(false);
      setOtp("");
      setPendingEmail("");
      setNewEmail("");
      setPassword("");
      setOtpSessionId("");
      setOtpUserId("");
      setLoadOTP(false);
    } catch (error) {
      setLoadOTP(false);
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(
          error.response?.data?.message || "OTP verification failed."
        );
        setShowErrorToast(true);
      }
    }
  };

  const resendOTP = async (e) => {
    if (seconds > 0 || minutes > 0) return;
    e.preventDefault();
    setMinutes(1);
    setSeconds(30);
    resetToasts();
    try {
      const res = await axios.post(
        `OAuth/ResendOTP?SessionID=${otpSessionId}&UserID=${otpUserId}&DeviceType=Web`
      );
      const responseData = res.data?.responseData || {};
      const nextSession =
        responseData.sessionID ||
        responseData.sessionId ||
        responseData.SessionID;
      if (nextSession) {
        setOtpSessionId(nextSession);
      }
      setToastMessage(res.data.message || "OTP resent.");
      setShowToast(true);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(
          error.response?.data?.message || "Failed to resend OTP."
        );
        setShowErrorToast(true);
      }
    }
  };

  useEffect(() => {
    if (!flag) return undefined;
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds((s) => s - 1);
      } else if (minutes > 0) {
        setSeconds(59);
        setMinutes((m) => m - 1);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [seconds, minutes, flag]);

  const [email, setEmail] = useState("");

  useEffect(() => {
    const storedEmail = localStorage.getItem("user-email");
    if (storedEmail) {
      setEmail(storedEmail);
    }
  }, []);

  // Clear any browser autofill that may populate the new email field
  useEffect(() => {
    const t = setTimeout(() => {
      if (!pendingEmail && !flag) {
        setNewEmail("");
      }
    }, 50);
    return () => clearTimeout(t);
  }, []);

  // -------------------------------------------------------------------------
  const { setIsNewsPageLoaded } = useNewsFeedStore();

  useEffect(() => {
    setIsNewsPageLoaded(true); // enable right panel when entering NewsFeed

    return () => setIsNewsPageLoaded(false); // optional cleanup when leaving
  }, [setIsNewsPageLoaded]);

  // -------------------------------------------------------------------------

  return (
    <>
      <div className="setting-header">
        <h4>{t("User Profile.Change Email Address")}</h4>
      </div>
      <div className="p-2 privacy">
        <div className="mb-3">
          <Form autoComplete="off">
            {/* Hidden field to discourage browser autofill */}
            <input
              type="text"
              name="fakeusernameremembered"
              style={{ display: "none" }}
              autoComplete="username"
            />
            <div className="row settings">
              <label className="mb-0 p-0 mb-1">
                {t("User Profile.Recent Email")}
              </label>
              <h6 className="p-0 f-600"> {email}</h6>

              <div className="col-12 mt-2 ps-0 mb-2 userInput">
                <label className="mb-0">
                  {t("User Profile.New Email Address")}
                </label>
                <input
                  type="email"
                  className="form-control"
                  name="new-email-address-manual"
                  autoComplete="off"
                  value={newEmail}
                  onChange={(e) => setNewEmail(e.target.value)}
                  placeholder={t("Manage Companies.Enter Email Id")}
                />
              </div>
              <div className="col-12 ps-0 mb-3">
                <label className="mb-0">{t("SignIn.Password")}</label>
                <input
                  type="password"
                  className="form-control"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder={t("SignIn.Password")}
                />
              </div>

              <div className="text-end">
                <button
                  type="button"
                  className="mainBtn1 mt-3 text-center"
                  onClick={handleChangeEmail}
                  disabled={loading}
                >
                  {loading
                    ? `${t("User Profile.Updating")}`
                    : `${t("User Profile.Update Email")}`}
                </button>
              </div>
            </div>
          </Form>
        </div>

        {flag && (
          <div
            className="modal fade show modal-md"
            tabIndex="-1"
            role="dialog"
            style={{ display: "block" }}
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="d-flex justify-content-end p-2 pb-0">
                  <CloseSharpIcon
                    className="material-symbols-sharp me-2 pointer mt-2"
                    onClick={handleOtpModalClose}
                  />
                </div>
                <div className="p-2 pt-2 text-center">
                  <h6>
                    <span className="fw-bold signUpModal">
                      Verify email by OTP
                    </span>
                  </h6>
                  <p>{otpMessage}</p>
                  {pendingEmail ? (
                    <p className="mb-0 small text-muted">{pendingEmail}</p>
                  ) : null}
                </div>
                <Form
                  className="auth-register-form mt-1 phoneSignUp pt-2 pb-3"
                  onSubmit={confirmEmailOtp}
                  style={{ display: flag ? "block" : "none" }}
                >
                  <div className="mb-1 d-flex justify-content-center otp-input">
                    <OtpInput
                      value={otp}
                      onChange={setOtp}
                      numInputs={4}
                      renderInput={(props) => <input {...props} />}
                    />
                  </div>

                  <div className="text-center mt-3">
                    <div className="countdown-text d-flex justify-content-center">
                      {seconds > 0 || minutes > 0 ? (
                        <p className="me-3">
                          Time Remaining:{" "}
                          {minutes < 10 ? `0${minutes}` : minutes}:
                          {seconds < 10 ? `0${seconds}` : seconds}
                        </p>
                      ) : (
                        <p className="me-3">Didn't receive code?</p>
                      )}

                      <span
                        style={{
                          color:
                            seconds > 0 || minutes > 0 ? "#DFE3E8" : "#FF5630",
                          pointerEvents:
                            seconds > 0 || minutes > 0 ? "none" : "auto",
                          cursor:
                            seconds > 0 || minutes > 0
                              ? "not-allowed"
                              : "pointer",
                        }}
                        onClick={resendOTP}
                        className={seconds > 0 || minutes > 0 ? "" : "pointer"}
                      >
                        Resend OTP
                      </span>
                    </div>
                    <button
                      type="submit"
                      className="mainBtn"
                      disabled={loadOTP || otp.length < 4}
                    >
                      {loadOTP ? "loading..." : "Verify OTP"}
                    </button>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        )}

        <SuccessToast
          show={showToast}
          message={toastMessage}
          onClose={() => setShowToast(false)}
        />
        <WarningToast
          show={showWarningToast}
          message={warningToastMessage}
          onClose={() => setShowWarningToast(false)}
        />
        <ErrorToast
          show={showErrorToast}
          message={errorToastMessage}
          onClose={() => setShowErrorToast(false)}
        />
      </div>
    </>
  );
};

export default ChangeEmailAddress;
